<template>
  <DsAnchorElement
      :tracking-data="{ text: title, 'component-name': $options.name }"
      :aria-label="title"
      :class="{ 'card-payment-method--white': themeLight }"
      :url="link"
      class="card-payment-method ds-width-full"
      :nuxt="false"
      :style="{ height: height || '100%' }"
  >
    <div class="ds-display-flex ds-flex-direction-column ds-background-color-white">
      <div
          v-if="image"
          class="card-payment-method__image-box
        ds-display-flex
        ds-justify-content-center
        ds-align-items-center"
          :style="computedBackgroundColor"
      >
        <img
            class="card-payment-method__image-box__image"
            :src="image.src"
            :alt="image.name"
        >
      </div>
      <div
          class="ds-display-flex
        ds-flex-direction-column
        ds-justify-content-center
        ds-align-items-start
        ds-padding-24"
          :class="[ themeLight ? 'ds-background-color-white' : 'ds-background-color-grey-200']"
      >
        <h3
            class="card-payment-method__title ds-heading-small"
            data-j-title
        >
          {{ title }}
        </h3>
        <h4
            class="ds-text-small ds-padding-top-4 ds-color-grey-450"
            data-j-subtitle
        >
          {{ subtitle }}
        </h4>
        <p
            class="ds-text ds-padding-top-12"
            data-j-desc
        >
          {{ description }}
        </p>
      </div>
    </div>
  </DsAnchorElement>
</template>
<script setup>
import {DsAnchorElement} from 'awds'

const {getBackgroundColor} = usePageUtils()
const opacity15 = 'D9'

const props = defineProps({
  link: {
    type: String,
    required: true
  },
  image: {
    type: Object,
    required: true,
    validator: obj => ['name', 'src', 'color'].every(key => key in obj)
  },
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  themeLight: {
    type: Boolean,
    default: false
  },
  height: {
    type: String,
    default: ''
  }
})

const computedBackgroundColor = computed(() => {
  return {backgroundColor: (getBackgroundColor(props.image?.color) + opacity15)}
})

</script>
<script>
export default {
  name: 'PaymentMethodsCard',
}
</script>
<style lang="scss" scoped>
@import 'awds/foundation-vars.scss';

@mixin pm-card-outline {
  outline: $border-width-2 $border-style $color-green-600;
  outline-offset: $border-width-2;
}

.card-payment-method {
  $this: &;

  background-color: $color-grey-200;
  display: block;
  overflow: hidden;

  &--white {
    background-color: $color-white;
  }

  &__image-box {
    height: 161px;
    width: 100%;

    &--default-background {
      /* This is a 15% white overlay over the default grey, to consider whether to update the ds color palette */
      background-color: #{$color-grey}D9;
    }

    &__image {
      height: 65px;
      transition: all 0.25s ease-in;
      width: 100px;
    }
  }

  // Hover state
  @media (hover: hover) {
    &:hover & {
      &__title {
        text-decoration: underline $color-black $border-width-1;
      }

      &__image-box {
        &__image {
          transform: scale(1.1);
        }
      }
    }
  }

  // Focus state: visible for keyboard navigation
  @supports (contain: none) {
    &:focus-visible {
      @include pm-card-outline;
    }
  }
  // fallback for browsers that don't support focus-visible and focus-within yet (Safari)
  @supports not (contain: none) {
    &:focus {
      @include pm-card-outline;
    }
  }
}
</style>
